import { render } from "./Committee.vue?vue&type=template&id=4d35db4e"
import script from "./Committee.vue?vue&type=script&lang=js"
export * from "./Committee.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__